export default [{
  path: '/factor',
  name: 'factor',
  component: resolve => require(['@/views/factor/factor.vue'], resolve),
  meta: {
    group: "/factor",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}]


// WEBPACK FOOTER //
// ./src/router/factor/factor.js